<template>
    <v-autocomplete
        dense
        :hide-details="hideDetails"
        :error="errorBorder"
        :error-messages="error"
        :items="options"
        :label="label"
        :loading="loading"
        multiple
        :readonly="readonly"
        item-text="label"
        item-value="value"
        outlined
        v-model="selectedValue"
        :search-input.sync="searchQuery"
    >
        <template #prepend-item>
            <slot name="firstItem"></slot>
        </template>

        <template #prepend>
            <slot name="prepend"></slot>
        </template>
    </v-autocomplete>
</template>

<script>
export default {
    name: 'DropdownMultiple',

    props: {
        readonly: Boolean,
        value: {
            type: Array,
            default: () => [],
        },
        ajax: Boolean,
        data: [Array, String],
        label: String,
        errorBorder: {type: Boolean, default: false},
        error: {type: String, default: ''},
    },

    data() {
        return {
            options: [],
            requestId: 0,
            loading: false,
            initialized: false,
            searchQuery: '',
        };
    },

    computed: {
        hideDetails() {
            return this.error === '';
        },

        selectedValue: {
            get() {
                return this.value || [];
            },
            set(val) {
                if (this.isEqual(val, this.value)) return;

                this.$emit('input', val);
                this.$emit('changes');

                this.$nextTick(() => {
                    this.searchQuery = '';
                });
            },
        },
    },

    watch: {
        value: {
            immediate: true,
            handler(newVal) {
                if (!this.initialized) {
                    this.initialized = true;
                    this.loadOptions(newVal);
                }

                this.ensureValuesInOptions(newVal);
            },
        },
    },

    methods: {
        isEqual(a = [], b = []) {
            if (a === b) return true;
            if (a.length !== b.length) return false;

            const sortedA = [...a].sort();
            const sortedB = [...b].sort();

            return sortedA.every((v, i) => v === sortedB[i]);
        },

        loadOptions(valuesForProtection) {
            if (!this.ajax) {
                this.options = this.data || [];
                this.ensureValuesInOptions(valuesForProtection);
                return;
            }

            const currentRequest = ++this.requestId;
            this.loading = true;
            this.$APICall(
                'get',
                'select/' + this.data,
                {values: valuesForProtection},
                (data, success) => {
                    if (currentRequest !== this.requestId) return;

                    this.loading = false;
                    if (!success) return;

                    this.options = data || [];

                    this.ensureValuesInOptions(this.value);
                },
                false,
            );
        },

        ensureValuesInOptions(values = []) {
            if (!Array.isArray(values) || values.length === 0) return;

            const missing = values.filter((val) => !this.options.find((o) => o.value === val));

            if (missing.length) {
                this.options = [
                    ...missing.map((val) => ({
                        value: val,
                        label: val,
                    })),
                    ...this.options,
                ];
            }
        },
    },
};
</script>
